export const FETCH_ABSENT_LAST5_REQUEST = "FETCH_ABSENT_LAST5_REQUEST";
export const FETCH_ABSENT_LAST5_SUCCESS = "FETCH_ABSENT_LAST5_SUCCESS";
export const FETCH_ABSENT_LAST5_FAILURE = "FETCH_ABSENT_LAST5_FAILURE";